import { render, staticRenderFns } from "./NlpSearchBar.vue?vue&type=template&id=4fff84b6"
import script from "./NlpSearchBar.vue?vue&type=script&lang=js"
export * from "./NlpSearchBar.vue?vue&type=script&lang=js"
import style0 from "./NlpSearchBar.vue?vue&type=style&index=0&id=4fff84b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports